export function redirectIfGuard(condition: () => boolean, routeName: string) {
    return function (_to, _from, next) {
        if (condition()) {
            next({
                name: routeName,
            });
        } else {
            next();
        }
    };
}
